import { Card, CardBody, CardTitle } from "reactstrap";
// icones
import { CiCircleCheck } from "react-icons/ci";
import { IoCloseCircleOutline } from "react-icons/io5";

export default function MessageUser(props) {
  const { step } = props;

  return (
    <>
      <Card className={"card-votorantim"}>
        <CardBody>
          {step === 2 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontSize: 20,
              }}
            >
              <span>Formulário respondido com sucesso!</span>
              <i style={{ fontSize: 30, color: "green" }}>
                <CiCircleCheck />
              </i>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontSize: 20,
              }}
            >
              <span>Erro ao validar usuário</span>
              <i style={{ fontSize: 30, color: "green" }}>
                <IoCloseCircleOutline />
              </i>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
}
